module.exports = __webpack_public_path__ + "img/sq-7.294cb84f.jpg";